import React, { useState, useMemo, useCallback } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Box from '@material-ui/core/Box';
import { Field } from 'formik';
import _ from 'lodash';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';

import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    FormControlLabel,
    RadioGroup,
    Radio,
    Grid,
    IconButton,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Card,
    CardContent,
    Typography,
    Button,
} from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';
import { downloadFile } from 'app/utils/forms/files';

import styles from './styles';
import DocumentField from 'app/components/DocumentField';
import { SERVICES_GROUPS, SERVICES_PROPERTIES } from 'app/config/services';
const useStyles = makeStyles(styles);

const ExpansionPanel = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(Accordion);

const ExpansionPanelSummary = withStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
}))(AccordionSummary);

const ExpansionPanelDetails = withStyles(() => ({
    root: {
        padding: '0',
    },
}))(AccordionDetails);

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

const TableData = (props) => {
    const { classes, rows, lastElement, canEdit, onChangeFile, onDeleteFile } = props;

    const [uploading, setUpLoading] = useState(false);
    const [expanded, setExpanded] = useState(() => {
        if (rows.length > 1) return null;
        return 0;
    });

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const dispatch = useDispatch();

    return (
        <div className={classes.accordion}>
            {rows && rows.length > 0 && (
                <>
                    {rows?.map((row, index) => {
                        return (
                            <ExpansionPanel
                                key={`expansionPanel-${index}`}
                                square
                                expanded={expanded === index}
                                onChange={handleChange(index)}>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header">
                                    <Typography className={classes.heading}>{row.label}</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Table className={classes.table} aria-label="customized table">
                                        <TableHead>
                                            <TableRow className={classes.tableRow}>
                                                <TableCell className={classes.headTableCell} align="center"></TableCell>
                                                <TableCell className={classes.headTableCell} align="left">
                                                    Documentos
                                                </TableCell>
                                                <TableCell className={classes.headTableCell} align="center">
                                                    Conformidade
                                                </TableCell>
                                                <TableCell className={classes.headTableCell} align="left">
                                                    Observações
                                                </TableCell>
                                                <TableCell className={classes.headTableCell} align="left"></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {row.documents.map((row, index) => {
                                                return (
                                                    <TableRow key={index} className={classes.tableRow}>
                                                        <TableCell align="center" component="th" scope="row">
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell align="left">{row.tpDocumento}</TableCell>
                                                        <TableCell align="center">{row.boConformidade}</TableCell>
                                                        <TableCell align="left">{row.deRevisaoDocumento}</TableCell>
                                                        {lastElement && canEdit && (
                                                            <TableCell align="right">
                                                                <Field
                                                                    value={row.fileName || null}
                                                                    required={row.boDocumentoObrigatorio}
                                                                    name={
                                                                        row.sgTipoDocumento
                                                                            ? row.sgTipoDocumento
                                                                            : `doc-${row.cdTipoDocumento}`
                                                                    }
                                                                    label={row.nmTipoDocumento}
                                                                    id={`doc-${row.cdTipoDocumento}-${row.lineNumber}`}
                                                                    idGdoc={row.idGdoc}
                                                                    idFile={row.idFile}
                                                                    onChangeFile={(docResult) => {
                                                                        onChangeFile(docResult, row.lineNumber);
                                                                        setUpLoading(false);
                                                                    }}
                                                                    onDeleteFile={(idFile) =>
                                                                        onDeleteFile(idFile, row.lineNumber)
                                                                    }
                                                                    uploading={uploading}
                                                                    setUpLoading={setUpLoading}
                                                                    onlyIcon={true}
                                                                    component={DocumentField}
                                                                />
                                                            </TableCell>
                                                        )}
                                                        {lastElement && !canEdit && row.idFile && (
                                                            <TableCell align="right">
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    className={classes.btnSigleAction}
                                                                    size="small"
                                                                    onClick={async () =>
                                                                        await downloadFile({
                                                                            idFile: row.idFile,
                                                                            dispatch,
                                                                        })
                                                                    }>
                                                                    <InsertDriveFileIcon fontSize="inherit" />
                                                                </Button>
                                                            </TableCell>
                                                        )}
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        );
                    })}
                </>
            )}
        </div>
    );
};

export default function Revisions(props) {
    const classes = useStyles();
    const theme = useTheme();
    const {
        filesStore,
        documentsToRevision,
        setDocumentsToRevision,
        generalObsertations,
        setGeneralObsertations,
        canEdit,
        tempJsonSolicitacao,
        setTempJsonSolicitacao,
    } = props;
    const revisions = useSelector((state) => state.revisions.revisions);
    const actualRevision = useSelector((state) => state.revisions.details);
    const request = useSelector((state) => state.requests.details);

    //NAVIGATION
    const totalElements = useMemo(() => {
        return Object.keys(revisions).length + 1;
    }, [revisions]);

    const [revisionIndex, setRevisionIndex] = useState(totalElements - 1);

    const handleChangeFieldRevision = (e, indexParam, type) => {
        e.preventDefault();
        let documentsResult = _.cloneDeep(documentsToRevision);
        let count = 0;
        documentsResult = documentsResult.map((docRevision) => {
            const result = _.cloneDeep(docRevision);
            const tempDocuments = [];
            result.documents.forEach((doc) => {
                const t = _.cloneDeep(doc);
                if (count === indexParam) {
                    t[type] = e.target.value;
                }
                count++;
                tempDocuments.push(t);
            });
            result.documents = tempDocuments;
            return result;
        });
        setDocumentsToRevision(documentsResult);
    };

    const onChangeFile = (docParam, indexParam) => {
        if (docParam.id) {
            let documentsResult = _.cloneDeep(documentsToRevision);
            let count = 0;
            documentsResult = documentsResult.map((docRevision) => {
                const result = _.cloneDeep(docRevision);
                const tempDocuments = [];
                result.documents.forEach((doc) => {
                    const t = _.cloneDeep(doc);
                    if (doc.idFile === docParam.id || count === indexParam) {
                        t.idFile = docParam.id;
                        t.boExcluido = false;
                        t.fileName = docParam.name;
                        t.name = docParam.name;
                        if (docParam.boAlterado) t.boAlterado = docParam.boAlterado;
                        if (docParam.idGdoc) t.idGdoc = docParam.idGdoc;

                        //UPDATE JSONSOLICITACAO ONLY IF LICENSES
                        if (SERVICES_GROUPS.LICENSE.includes(request.cdServico)) {
                            const json = _.cloneDeep(tempJsonSolicitacao);

                            const grouper = SERVICES_PROPERTIES[request.cdServico].payloadDocumentsGrouper;
                            if (grouper && t.cdVeiculo) {
                                json[grouper] = json[grouper].map((ele) => {
                                    const tempEle = _.cloneDeep(ele);
                                    if (ele.cdVeiculo && ele.cdVeiculo === t.cdVeiculo) {
                                        if (tempEle.veiculo?.documentos) {
                                            const found = _.find(tempEle.veiculo.documentos, [
                                                'cdTipoDocumento',
                                                t.cdTipoDocumento,
                                            ]);
                                            if (!found) {
                                                tempEle.veiculo.documentos.push(t);
                                            }
                                        }
                                        if (tempEle.veiculoSubstituir?.documentos) {
                                            const found = _.find(tempEle.veiculoSubstituir.documentos, [
                                                'cdTipoDocumento',
                                                t.cdTipoDocumento,
                                            ]);
                                            if (!found) {
                                                tempEle.veiculoSubstituir.documentos.push(t);
                                            }
                                        }
                                    }
                                    return tempEle;
                                });
                            }

                            const found = _.find(json.documentos, ['cdTipoDocumento', t.cdTipoDocumento]);
                            if (!found) {
                                json.documentos.push(t);
                            }

                            setTempJsonSolicitacao(json);
                        }
                    }
                    count++;
                    tempDocuments.push(t);
                });
                result.documents = tempDocuments;
                return result;
            });
            setDocumentsToRevision(documentsResult);
        }
    };

    const onDeleteFile = (idFile, indexParam) => {
        let documentsResult = _.cloneDeep(documentsToRevision);
        let count = 0;
        documentsResult = documentsResult.map((docRevision) => {
            const result = _.cloneDeep(docRevision);
            const tempDocuments = [];
            result.documents.forEach((doc) => {
                const t = _.cloneDeep(doc);
                if (doc.idFile === idFile || count === indexParam) {
                    t.boExcluido = true;
                }
                count++;
                tempDocuments.push(t);
            });
            result.documents = tempDocuments;
            return result;
        });
        setDocumentsToRevision(documentsResult);
    };

    const concatObservations = () => {
        const observations = [];
        documentsToRevision.forEach((docRev) => {
            if (docRev.documents) {
                docRev.documents.forEach((doc) => {
                    if (doc.deRevisaoDocumento && doc.deRevisaoDocumento !== '') {
                        observations.push(doc.deRevisaoDocumento);
                    }
                });
            }
        });
        setGeneralObsertations(observations.join(' '));
    };

    const generateRows = useCallback(
        (indexRevision) => {
            let lineCount = 0;
            let documents;
            if (indexRevision !== null) {
                documents = _.cloneDeep(filesStore[indexRevision]);
            } else {
                documents = _.cloneDeep(documentsToRevision);
            }

            documents = documents.map((docRev) => {
                const result = _.cloneDeep(docRev);
                result.documents = result.documents.map((doc) => {
                    const temp = _.cloneDeep(doc);
                    temp.nmTipoDocumento =
                        temp.nmTipoDocumento || temp.tipoDocumento?.nmTipoDocumento || temp.deDescricao;
                    temp.sgTipoDocumento = temp.sgTipoDocumento || temp.tipoDocumento?.sgTipoDocumento || '';

                    if (temp.boConformidade == null) temp.boConformidade = '';
                    if (temp.deRevisaoDocumento == null) temp.deRevisaoDocumento = '';
                    return temp;
                });
                return result;
            });

            return documents.map((docRevision) => {
                const result = _.cloneDeep(docRevision);
                result.documents = result.documents.map((doc) => {
                    const lineNumber = lineCount;

                    let nameDocument =
                        doc.deDescricao && doc.deDescricao !== '' ? doc.deDescricao : doc.nmTipoDocumento;

                    if (nameDocument === doc.fileName && doc.nmTipoDocumento && doc.nmTipoDocumento !== '') {
                        nameDocument = doc.nmTipoDocumento;
                    }

                    const result = {
                        ...doc,
                        lineNumber,
                        tpDocumento:
                            !canEdit || indexRevision !== null ? (
                                <>{nameDocument}</>
                            ) : (
                                <Field
                                    name={`documentos[${lineNumber}].cdTipoDocumento`}
                                    value={nameDocument}
                                    margin="dense"
                                    fullWidth
                                    multiline
                                    disabled
                                    as={TextField}
                                />
                            ),
                        boConformidade:
                            !canEdit || indexRevision !== null ? (
                                <>{doc.boConformidade ? 'Sim' : 'Não'}</>
                            ) : (
                                <>
                                    <RadioGroup
                                        row
                                        aria-label="boConformidade"
                                        name={`documentos[${lineNumber}].boConformidade`}
                                        value={String(doc.boConformidade)}
                                        onChange={(e) => handleChangeFieldRevision(e, lineNumber, 'boConformidade')}>
                                        <FormControlLabel
                                            value={'true'}
                                            control={<Radio color="secondary" />}
                                            label="Sim"
                                            disabled={!canEdit}
                                        />
                                        <FormControlLabel
                                            value={'false'}
                                            control={<Radio color="secondary" />}
                                            label="Não"
                                            disabled={!canEdit}
                                        />
                                    </RadioGroup>
                                </>
                            ),
                        deRevisaoDocumento:
                            !canEdit || indexRevision !== null ? (
                                <>{doc.deRevisaoDocumento}</>
                            ) : (
                                <Field
                                    name={`documentos[${lineNumber}].deRevisaoDocumento`}
                                    margin="dense"
                                    // disabled={hasRevisionOk || !canEdit}
                                    disabled={!canEdit}
                                    multiline
                                    value={doc.deRevisaoDocumento}
                                    rows={1}
                                    fullWidth
                                    onChange={(e) => handleChangeFieldRevision(e, lineNumber, 'deRevisaoDocumento')}
                                    onBlur={(e) => concatObservations(e)}
                                    as={TextField}
                                    inputProps={{
                                        maxLength: 300,
                                    }}
                                />
                            ),
                    };
                    lineCount++;
                    return result;
                });

                return result;
            });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [actualRevision, canEdit, documentsToRevision],
    );

    const handleChangeIndex = (index) => {
        setRevisionIndex(index);
    };

    return (
        <div className={classes.root}>
            <Grid container spacing={1} className={classes.containerNavigation}>
                <Grid item xs={6} sm={4} md={3}>
                    <Box className={classes.feedbackNavigation}>
                        <Box className={classes.revisionNumber}>{revisionIndex + 1}</Box>
                        <Box>Revisões</Box>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={4} md={3}>
                    <Box className={classes.navegation}>
                        <IconButton
                            component="span"
                            onClick={() => setRevisionIndex(revisionIndex - 1 < 0 ? 0 : revisionIndex - 1)}>
                            <ArrowBackIcon />
                        </IconButton>{' '}
                        <Box>
                            {revisionIndex + 1} de {totalElements}
                        </Box>
                        <IconButton
                            component="span"
                            onClick={() =>
                                setRevisionIndex(
                                    revisionIndex >= totalElements - 1 ? totalElements - 1 : revisionIndex + 1,
                                )
                            }>
                            <ArrowForwardIcon />
                        </IconButton>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={4} md={6}>
                    <Box className={classes.navegation}>
                        <hr className={classes.line} />
                    </Box>
                </Grid>
            </Grid>

            <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={revisionIndex}
                onChangeIndex={handleChangeIndex}>
                {revisions &&
                    Object.keys(revisions).map((keyRevision, index) => {
                        return (
                            <TabPanel key={index} value={revisionIndex} index={index} dir={theme.direction}>
                                <TableData
                                    classes={classes}
                                    lastElement={false}
                                    canEdit={canEdit}
                                    onChangeFile={onChangeFile}
                                    onDeleteFile={onDeleteFile}
                                    rows={generateRows(index)}
                                />
                                {revisions[keyRevision].deRevisao && revisions[keyRevision].deRevisao !== '' && (
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Typography gutterBottom component="h3">
                                                    Observações
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary" component="p">
                                                    {revisions[keyRevision].deRevisao}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                )}
                            </TabPanel>
                        );
                    })}
                <TabPanel key={totalElements} value={revisionIndex} index={totalElements - 1} dir={theme.direction}>
                    <TableData
                        classes={classes}
                        lastElement={true}
                        canEdit={canEdit}
                        onChangeFile={onChangeFile}
                        onDeleteFile={onDeleteFile}
                        rows={generateRows(null)}
                    />
                    <Grid item xs={12}>
                        <Field
                            name="deRevisao"
                            label="Observações Gerais"
                            variant="filled"
                            margin="dense"
                            multiline
                            minRows={4}
                            disabled={!canEdit}
                            fullWidth
                            as={TextField}
                            value={generalObsertations}
                            onChange={(e) => setGeneralObsertations(e.target.value)}
                            inputProps={{
                                maxLength: 4900,
                            }}
                        />
                    </Grid>
                </TabPanel>
            </SwipeableViews>
        </div>
    );
}
